import { useClientContext } from "@hooks/index";
import { useMemo } from "react";
import { getDangerZone, updateDangerZone } from "./index";

export const useDangerZone = () => {
  const customFetch = useClientContext();

  return useMemo(
    () => ({
      getDangerZone: getDangerZone(customFetch),
      updateDangerZone: updateDangerZone(customFetch),
    }),
    [customFetch]
  );
};
